import { styled } from "@mui/material/styles";
import { FC } from "react";
import MessageCard, {
  MessageCardProps,
} from "../../components/card/MessageCard";
import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";

export const StyledMesssageCard = styled(MessageCard)(({ theme }) => ({
  width: "100%",
  maxWidth: "880px",
  padding: "35px 23px",
  backgroundColor:
    theme.componentStyleOverrides?.emptyBagMessageCard?.backgroundColor,
  color: theme.componentStyleOverrides?.emptyBagMessageCard?.textColor,

  ".store-message-card__cta": {
    width: "100%",
    maxWidth: 355,
    marginTop: 20,
    backgroundColor:
      theme.componentStyleOverrides?.emptyBagMessageCardButton?.backgroundColor,
    color: theme.componentStyleOverrides?.emptyBagMessageCardButton?.textColor,
    borderRadius:
      theme.componentStyleOverrides?.emptyBagMessageCardButton
        ?.globalButtonRadius,
  },

  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    ".store-message-card__cta": {
      marginTop: 10,
    },
  },
}));

export const EmptyBagMessageCard: FC<Partial<MessageCardProps>> = (props) => {
  const linkTo = window.location.origin;

  return (
    <StyledMesssageCard
      title="Your bag is empty."
      content="Can we make some suggestions to help get you started?"
      cta="Shop popular products"
      linkTo={linkTo}
      {...props}
    />
  );
};
